import { Component } from '@theme/component';

/**
 * @typedef {object} BundleRefs
 * @property {HTMLElement} printField
 * @property {HTMLSelectElement} print
 * @property {HTMLSelectElement} variant
 * @property {HTMLInputElement} bandQuantity
 * @property {HTMLElement} price
 * @property {HTMLImageElement | undefined} bandImage
 * @extends Component<BundleRefs>
 */
class MsConnectorBundle extends Component {
  #groups = [];

  connectedCallback() {
    super.connectedCallback();
    this.#initialize();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#initialize();
  }

  #initialize() {
    // A section morph may replace the complete native fallback list. Keep a local copy before filtering it.
    const groups = [...this.refs.variant.querySelectorAll('optgroup')];
    if (groups.length > 1 || this.#groups.length === 0) this.#groups = groups.map((group) => group.cloneNode(true));
    this.refs.printField.hidden = false;
    this.changePrint();
  }

  /** Choose the print first, then expose only its real available variants. */
  changePrint() {
    const group = this.#groups.find((group) => group.dataset.product === this.refs.print.value);
    if (!group) return;
    this.refs.variant.replaceChildren(group.cloneNode(true));
    this.changeVariant();
  }

  /** Update the combined price and preview without inventing a discount or changing inventory. */
  changeVariant() {
    const option = this.refs.variant.selectedOptions[0];
    if (!option) return;
    const quantity = Number(option.dataset.quantity) || 1;
    this.refs.bandQuantity.value = String(quantity);
    const total = Number(option.dataset.price) * quantity + Number(this.dataset.connectorPrice);
    this.refs.price.textContent = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency }).format(total / 100);
    if (this.refs.bandImage && option.dataset.image) {
      this.refs.bandImage.removeAttribute('srcset');
      this.refs.bandImage.src = option.dataset.image;
    }
  }
}
if (!customElements.get('ms-connector-bundle')) customElements.define('ms-connector-bundle', MsConnectorBundle);
